var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C7.34315 2 6 3.34315 6 5C6 6.65685 7.34315 8 9 8C10.6569 8 12 6.65685 12 5C12 3.34315 10.6569 2 9 2ZM4 5C4 2.23858 6.23858 0 9 0C11.7614 0 14 2.23858 14 5C14 7.76142 11.7614 10 9 10C6.23858 10 4 7.76142 4 5ZM2.29209 15.5805C2.01022 15.8304 2 15.9745 2 16C2 16.0255 2.01022 16.1696 2.29209 16.4195C2.57279 16.6683 3.03602 16.9381 3.69427 17.185C5.0034 17.6759 6.87903 18 9 18C11.121 18 12.9966 17.6759 14.3057 17.185C14.964 16.9381 15.4272 16.6683 15.7079 16.4195C15.9898 16.1696 16 16.0255 16 16C16 15.9745 15.9898 15.8304 15.7079 15.5805C15.4272 15.3317 14.964 15.0619 14.3057 14.815C12.9966 14.3241 11.121 14 9 14C6.87903 14 5.0034 14.3241 3.69427 14.815C3.03602 15.0619 2.57279 15.3317 2.29209 15.5805ZM2.99202 12.9424C4.57833 12.3475 6.70269 12 9 12C11.2973 12 13.4217 12.3475 15.008 12.9424C15.7974 13.2384 16.5058 13.615 17.0347 14.084C17.5625 14.5519 18 15.1971 18 16C18 16.8029 17.5625 17.4481 17.0347 17.916C16.5058 18.385 15.7974 18.7616 15.008 19.0576C13.4217 19.6525 11.2973 20 9 20C6.70269 20 4.57833 19.6525 2.99202 19.0576C2.20256 18.7616 1.49422 18.385 0.965273 17.916C0.437492 17.4481 0 16.8029 0 16C0 15.1971 0.437492 14.5519 0.965273 14.084C1.49422 13.615 2.20256 13.2384 2.99202 12.9424Z",
    fill: "#000A19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.359e542956f218a6330f24463a70eddc.svg";
export { ForwardRef as ReactComponent };